import actions from "./actions";
import mutations from "./mutation";

export default {
  namespaced: true,
  state: {
    projects: [],
    project: null,
    tasks: [],
    task: null,
    taskStatuses: [],
    tableLoading: false,
    currentPage: 1,
    perPage: 5,
    searchQuery: "",
    total: 0,
    selectedRow: null,
  },
  actions,
  mutations,
};
